import { memo } from "react";
import { WarningContainer } from "../styles";
import { FormattedMessage } from "react-intl";
import { messages } from "../messages";
import { Accommodation } from "../../../gen/witbooking/backoffice/accommodation/v1/accommodation_api_pb";

type NoImagesWarningProps = {
  accommodations: Accommodation.AsObject[];
};

export const NoImagesWarning = memo(({ accommodations }: NoImagesWarningProps) => {
  // Filter the accommodations without images
  const accommodationsWithoutImages = accommodations.filter(
    accommodation => !accommodation.multimediaList?.length
  );

  // If there are no accommodations without images, it does not show anything.
  if (!accommodationsWithoutImages.length) {
    return null;
  }

  // Obtains housing accommodation tickers without images
  const tickersWithoutImages = accommodationsWithoutImages.map(acc => acc.ticker).join(", ");

  return (
    <WarningContainer>
      <FormattedMessage {...messages.noImagesWarning} />
      {tickersWithoutImages}.
    </WarningContainer>
  );
});
